import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';

/**
 * P Image Badge Setting Handler
 */
export class ShBadgePositon extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {
    // this.set$el(options.$atom);
    // this.setAtomModel(options.atomModel);
    // let value: any = options.$activePanel.find("#")
    // options.$activePanel.find("#secondBackgound").attr("value", secondBackgound).val(secondBackgound).trigger("value-change");
  }

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $atom: JQuery;
      $activePanel: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;
    const $self = this.getAtomTarget('write', this);
    let style = this.getAtomModel().style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    if (!targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      if (this.setting.options?.length) {
        for (let i = 0; i < this.setting.options.length; i++) {
          const option = this.setting.options[i];
          if (option.key == value) {
            value = option.value;
          }
        }
      }
      const degVal = options.$activePanel.find('#badgeRotateFrame').val() as string;
      let listTransForm = '';
      const rotateDeg = degVal ? parseInt(degVal) : 0;
      const positionSelected = options.$activePanel.find('#badgePosition').val();
      let deOptions: any = [];
      listTransForm = `rotate(${rotateDeg}deg)`;
      if (positionSelected == 'top-left') {
        deOptions = [
          {
            key: 'top',
            value: options.$activePanel.find('#badgePositionTop').val(),
          },
          {
            key: 'left',
            value: options.$activePanel.find('#badgePositionLeft').val(),
          },
          {
            key: 'bottom',
            value: 'unset',
          },
          {
            key: 'right',
            value: 'unset',
          },
          {
            key: 'transform',
            value: listTransForm,
          },
        ];
      } else if (positionSelected == 'top-right') {
        deOptions = [
          {
            key: 'top',
            value: options.$activePanel.find('#badgePositionTop').val(),
          },
          {
            key: 'right',
            value: options.$activePanel.find('#badgePositionRight').val(),
          },
          {
            key: 'bottom',
            value: 'unset',
          },
          {
            key: 'left',
            value: 'unset',
          },
          {
            key: 'transform',
            value: listTransForm,
          },
        ];
      } else if (positionSelected == 'bottom-right') {
        deOptions = [
          {
            key: 'bottom',
            value: options.$activePanel.find('#badgePositionBottom').val(),
          },
          {
            key: 'right',
            value: options.$activePanel.find('#badgePositionRight').val(),
          },
          {
            key: 'top',
            value: 'unset',
          },
          {
            key: 'left',
            value: 'unset',
          },
          {
            key: 'transform',
            value: listTransForm,
          },
        ];
      } else if (positionSelected == 'bottom-left') {
        deOptions = [
          {
            key: 'bottom',
            value: options.$activePanel.find('#badgePositionBottom').val(),
          },
          {
            key: 'left',
            value: options.$activePanel.find('#badgePositionLeft').val(),
          },
          {
            key: 'top',
            value: 'unset',
          },
          {
            key: 'right',
            value: 'unset',
          },
          {
            key: 'transform',
            value: listTransForm,
          },
        ];
      } else if (positionSelected == 'center') {
        deOptions = [
          {
            key: 'top',
            value: '50%',
          },
          {
            key: 'left',
            value: '50%',
          },
          {
            key: 'bottom',
            value: 'unset',
          },
          {
            key: 'right',
            value: 'unset',
          },
          {
            key: 'transform',
            value: `rotate(${rotateDeg}deg) translate(-50%, -50%)`,
          },
        ];
      }
      style = HELPER.designOptions2Style($self, options.screenType, style, deOptions, '.gf_product-badge-anchor');
    }
    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}
